import { FetchFn } from '@Types/fetcher'
import useShopifyFetcher from '../shopify'

export type PanelEntry = {
  company_id: number
  name: string
  is_root: boolean
  enabled: boolean
  shopify_market_panel: {
    shopify_market_id: string
    catalog_id: string | null
    publication_id: string | null
    price_list_id: string | null
    currency_code: string
    country_code: string | null
  } | null
}

function useGetPanels(): [
  FetchFn,
  {
    data: PanelEntry[] | null
    isLoading: boolean
    isError: boolean
    isSuccess: boolean
    isFinished: boolean
  },
] {
  const [baseFetcher, meta] = useShopifyFetcher()

  const fetchPanels = async () => {
    return await baseFetcher(`${import.meta.env.VITE_APP_URL}/shopify/panels`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  return [
    fetchPanels,
    {
      data: meta.data,
      isLoading: meta.isLoading,
      isError: meta.isError,
      isSuccess: meta.isSuccess,
      isFinished: meta.isFinished,
    },
  ]
}

export default useGetPanels
